import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeMnemonicsPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content._context";
import { useEffect, useMemo } from "react";

export function MorphemeMnemonicsMeaningViewTabFloatingActions({
  isEditing,
  onEditPress,
  showEditButton,
}: {
  isEditing: boolean;
  onEditPress: () => void;
  showEditButton: boolean;
}) {
  const [isFlashcardEditPending, onFlashcardEditPendingChange, onToolbarEditActionChange] =
    useContextSelectors(
      MorphemeMnemonicsPanelContext,
      (c) => c.isFlashcardEditPending,
      (c) => c.onFlashcardEditPendingChange,
      (c) => c.onToolbarEditActionChange,
    );
  const toolbarEditAction = useMemo(
    () => (showEditButton ? { isEditing, onPress: onEditPress } : null),
    [onEditPress, isEditing, showEditButton],
  );

  useEffect(() => {
    onToolbarEditActionChange?.(toolbarEditAction);
    return () => {
      onToolbarEditActionChange?.(null);
    };
  }, [onToolbarEditActionChange, toolbarEditAction]);

  // Edit Flashcard pressed where no reading was selected (the Details menu): the pager has opened
  // this reading. Only the selected reading publishes its edit action, so only it takes the request.
  useEffect(() => {
    if (!isFlashcardEditPending || onToolbarEditActionChange === undefined) {
      return;
    }
    onFlashcardEditPendingChange?.(false);
    if (showEditButton && !isEditing) {
      onEditPress();
    }
  }, [
    isEditing,
    isFlashcardEditPending,
    onEditPress,
    onFlashcardEditPendingChange,
    onToolbarEditActionChange,
    showEditButton,
  ]);

  return null;
}
